import EngineService from '../core/engine-service';

const ENDPOINT = '/assistant';

export function getRuleResources(params = {}) {
  return EngineService.get(`${ENDPOINT}/resources`, params).then((json) => json);
}
